import { colors } from "widgets/utils";

import { useGenomeViewerStore } from "../../store/store.ts";
import { alignToLeftPixelGrid } from "../../utils/graphics/align-to-pixel-grid.ts";

export function rangeSelectionRenderer(height: number) {
  const { basePerPixel, ctx, selectedRange, scrollX } = useGenomeViewerStore.getState();

  if (ctx && selectedRange) {
    const startX = alignToLeftPixelGrid(selectedRange.start / basePerPixel - scrollX);
    const stopX = alignToLeftPixelGrid(selectedRange.stop / basePerPixel - scrollX);
    const width = stopX - startX;

    ctx.save();

    ctx.globalAlpha = 0.7;
    ctx.fillStyle = colors.selectedRow;
    ctx.fillRect(startX, 0, width, height);

    ctx.restore();
  }
}
